var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRacecheckAiOutline = function SvgRacecheckAiOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_663_1823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5842 5.64843L4.6492 3.21769C4.63516 3.18121 4.61041 3.14984 4.57819 3.12772C4.54597 3.10559 4.50781 3.09375 4.46873 3.09375C4.42964 3.09375 4.39148 3.10559 4.35926 3.12772C4.32704 3.14984 4.30229 3.18121 4.28826 3.21769L3.35326 5.64843C3.34355 5.67369 3.32864 5.69663 3.30951 5.71576C3.29037 5.73489 3.26744 5.7498 3.24218 5.75951L0.811441 6.69451C0.774964 6.70854 0.743595 6.73329 0.721469 6.76551C0.699343 6.79773 0.6875 6.83589 0.6875 6.87498C0.6875 6.91406 0.699343 6.95222 0.721469 6.98444C0.743595 7.01666 0.774964 7.04141 0.811441 7.05545L3.24218 7.99045C3.26744 8.00016 3.29037 8.01506 3.30951 8.03419C3.32864 8.05333 3.34355 8.07626 3.35326 8.10152L4.28826 10.5323C4.30229 10.5687 4.32704 10.6001 4.35926 10.6222C4.39148 10.6444 4.42964 10.6562 4.46873 10.6562C4.50781 10.6562 4.54597 10.6444 4.57819 10.6222C4.61041 10.6001 4.63516 10.5687 4.6492 10.5323L5.5842 8.10152C5.59391 8.07626 5.60881 8.05333 5.62794 8.03419C5.64708 8.01506 5.67001 8.00016 5.69527 7.99045L8.12601 7.05545C8.16249 7.04141 8.19386 7.01666 8.21598 6.98444C8.23811 6.95222 8.24995 6.91406 8.24995 6.87498C8.24995 6.83589 8.23811 6.79773 8.21598 6.76551C8.19386 6.73329 8.16249 6.70854 8.12601 6.69451L5.69527 5.75951C5.67001 5.7498 5.64708 5.73489 5.62794 5.71576C5.60881 5.69663 5.59391 5.67369 5.5842 5.64843Z",
    stroke: "#FFD80E",
    strokeWidth: 0.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.32031 1.46094L1.89062 0.34375L1.46094 1.46094L0.34375 1.89062L1.46094 2.32031L1.89062 3.4375L2.32031 2.32031L3.4375 1.89062L2.32031 1.46094Z",
    stroke: "#41E2EC",
    strokeWidth: 0.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16674 2.52076L8.59375 1.03125L8.02076 2.52076L6.53125 3.09375L8.02076 3.66674L8.59375 5.15625L9.16674 3.66674L10.6562 3.09375L9.16674 2.52076Z",
    stroke: "#DB6DD6",
    strokeWidth: 0.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_663_1823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRacecheckAiOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/racecheck-ai_outline.200905d2.svg";
export { ForwardRef as ReactComponent };